import {
  AddTaskAccess,
  AddTaskAccessComplete,
  DeleteTaskAccess,
  DeleteTaskAccessComplete,
  DeleteTaskAccessesComplete,
  LoadTaskAccessesComplete,
  UpdateTaskAccess,
  UpdateTaskAccessComplete,
  ArchiveTaskAccessesComplete,
  UnarchiveTaskAccessesComplete,
} from './actions'
import { adapter, initialState, State } from './state'
import * as R from 'ramda'
import { Action, createReducer, on } from '@ngrx/store'

export const reducer = createReducer(
  initialState,
  on(LoadTaskAccessesComplete, (state, { tasks }) =>
    adapter.addMany(tasks, R.merge(state, { isLoaded: true, isUpdating: false }))
  ),
  on(AddTaskAccessComplete, (state, { task }) => adapter.addOne(task, { ...state, isUpdating: false })),
  on(DeleteTaskAccessComplete, (state, { id }) => adapter.removeOne(id, { ...state, isUpdating: false })),
  on(DeleteTaskAccessesComplete, (state, { ids }) => adapter.removeMany(ids, { ...state, isUpdating: false })),
  on(UpdateTaskAccessComplete, (state, { update }) => adapter.updateOne(update, { ...state, isUpdating: false })),
  on(ArchiveTaskAccessesComplete, UnarchiveTaskAccessesComplete, (state, { updates }) =>
    adapter.updateMany(updates, state)
  ),
  on(AddTaskAccess, UpdateTaskAccess, DeleteTaskAccess, (state) => ({
    ...state,
    isUpdating: true,
  }))
)

export function taskAccessesReducer(state: State | undefined, action: Action) {
  return reducer(state, action)
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors()
